<template>
  <section class="section">
    <h2 class="section-title">公司简介</h2>
    <div class="card" v-for="(text, index) in introTexts" :key="index">
      <p class="section-text" v-html="text"></p>
    </div>
  </section>
</template>

<script setup>
const introTexts = [
  `深圳量德信息技术有限公司成立于2022年，位于中国创新之都——深圳，是一家专注于软件开发、系统集成、技术咨询与服务的国家高新技术企业。公司以“技术驱动创新，服务创造价值”为使命，致力于为客户提供高效、稳定、可持续的软件整体解决方案。`,

  `公司主营业务涵盖MES制造执行系统、ERP企业资源计划、WMS仓储管理系统、EAP系统、物联网（IoT）平台、移动应用（APP）开发、微信小程序开发、数据采集与分析系统等，已广泛应用于制造、医疗、电商、物流等多个行业领域。`,

  `公司核心团队由来自国内一线科技企业的技术专家组成，拥有丰富的软件架构设计、项目开发实施与系统集成经验。自创办以来，量德始终坚持以客户需求为导向，不断提升服务质量与技术实力，赢得了众多合作伙伴的信赖与好评。`,

  `系统平台网址：<a href="http://139.9.5.118:9010" target="_blank" rel="noopener noreferrer">http://139.9.5.118:9010</a>`,

  `当前，公司正处于快速发展阶段，未来将持续深耕智能制造与数字化转型领域，致力于成为行业领先、客户信赖的软件技术服务商。`
]
</script>

<style scoped>
.section {
  max-width: 800px;
  margin: 0 auto;
  padding: 2em 1em;
  box-sizing: border-box;
  text-align: left;
}

.section-title {
  font-size: 1.8em;
  font-weight: bold;
  margin-bottom: 1.5em;
  color: #0a74da;
  text-align: center;
}

.card {
  background: #f9f9f9;
  padding: 1.2em 1.5em;
  margin-bottom: 1.5em;
  border-radius: 10px;
  box-shadow: 0 3px 8px rgba(0,0,0,0.1);
}

.section-text {
  font-size: 1em;
  line-height: 1.6;
  color: #333;
}

.section-text a {
  color: #0a74da;
  text-decoration: underline;
}
</style>
